import TransformedHtml from '~/components/Editor';

interface Props {
  html: string;
  slug: string;
}

const PageHtml = ({ html, slug }: Props) => {
  return (
    <div className="relative mt-6">
      <TransformedHtml html={html} slug={slug} />
    </div>
  );
};

export default PageHtml;
